import { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'

import { useAppConfig } from '../../request/query/app'

const toList = (value) => (Array.isArray(value) ? value : [value])

const hasCodename = (userPermissions, codename) =>
  (userPermissions || []).some((entry) => (entry || {}).codename === codename)

const hasAnyCodename = (userPermissions = [], codenames) =>
  toList(codenames).some((codename) => hasCodename(userPermissions, codename))

const hasAllCodenames = (userPermissions = [], codenames) =>
  toList(codenames).every((codename) => hasCodename(userPermissions, codename))

// NOT by event attribute: hide subtree when target carries a blocked
// id/code/other value. notMatch: { code: [...], id: [...] }, target: event.
const isBlockedByNotMatch = (notMatch, target) => {
  if (!notMatch || !target) return false
  return Object.keys(notMatch).some((key) =>
    toList(notMatch[key]).some((blocked) => get(target, key) === blocked)
  )
}

export class PermissionChecker extends Component {
  render() {
    const {
      userPermissions,
      requiredPermission,
      requiredMode,
      notPermission,
      notMatch,
      target
    } = this.props || {}

    // OR is the default: any listed codename grants. requiredMode="all" = AND.
    const granted = requiredPermission
      ? (requiredMode === 'all'
        ? hasAllCodenames(userPermissions, requiredPermission)
        : hasAnyCodename(userPermissions, requiredPermission))
      : true
    if (!granted) return null

    // NOT: denied codename hides even when granted.
    if (notPermission && hasAnyCodename(userPermissions, notPermission)) return null

    // NOT: blocked event id/code/other hides even when granted.
    if (isBlockedByNotMatch(notMatch, target)) return null

    return this.props.children
  }
}

PermissionChecker.propTypes = {
  userPermissions: PropTypes.array.isRequired,
  requiredPermission: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  requiredMode: PropTypes.oneOf(['any', 'all']),
  notPermission: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  notMatch: PropTypes.object,
  target: PropTypes.any,
  children: PropTypes.node
}

PermissionChecker.defaultProps = {
  userPermissions: [],
  requiredPermission: null,
  requiredMode: 'any',
  notPermission: null,
  notMatch: null,
  target: null,
  children: null
}

const Wrapper = ({ userPermissions, ...rest }) => (
  <PermissionChecker userPermissions={userPermissions} {...rest} />
)

export { hasAnyCodename, hasAllCodenames, isBlockedByNotMatch }

export default function WrappedPermissionChecker(props) {
  const { userPermissions } = useAppConfig()
  return <Wrapper userPermissions={userPermissions} {...props} />
}
